export const threadIdFromProps = (state, props = {}) => props.threadId;